import {
  FETCH_ALL_MYCOINS_TRANSACTIONS_SUCCESS,
  DOWNLOAD_MYCOINS_TRANSACTIONS
} from '../constant/actionType';

import { getAllMycoinsTransactions, downloadMyCoinsTransactions } from '../services/napi';

export function fetchAllTransactionsAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getAllMycoinsTransactions(projectId);
    dispatch({
      data: response.data.transactions,
      type: FETCH_ALL_MYCOINS_TRANSACTIONS_SUCCESS
    });
  };
}

export function downloadMyCoinsTransactionsAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadMyCoinsTransactions(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `transactions.csv`);
    document.body.appendChild(link);
    link.click();
    dispatch({
      data: response.data,
      type: DOWNLOAD_MYCOINS_TRANSACTIONS
    });
  };
}
